import { render, staticRenderFns } from "./faqPopup.vue?vue&type=template&id=6bb36f62&scoped=true"
import script from "./faqPopup.vue?vue&type=script&lang=js"
export * from "./faqPopup.vue?vue&type=script&lang=js"
import style0 from "./faqPopup.vue?vue&type=style&index=0&id=6bb36f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb36f62",
  null
  
)

export default component.exports